export default __webpack_public_path__ + "static/subscribe-pattern-ed8d71de6c68c30a4a5694e69ba0d4f1.png";